// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RoutesProgressDetailsPage_pageRoot__oT7Sv { padding: 16px; }

/* Header */
.RoutesProgressDetailsPage_header__ryNXj {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.RoutesProgressDetailsPage_title__APUaS { margin: 0; font-size: 20px; font-weight: 800; }
.RoutesProgressDetailsPage_headerActions__5aGsz { display: flex; gap: 8px; }
.RoutesProgressDetailsPage_primaryBtn__5smmY {
  padding: 6px 12px;
  border-radius: 999px;
  background: #111827;
  color: #fff;
  border: 1px solid #111827;
  font-weight: 800;
  cursor: pointer;
}

/* Active filter tags (фикс высоты, выравнивание) */
.RoutesProgressDetailsPage_activeFilters__gX0c6 {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;      /* фикс вертикального выравнивания */
  margin: 6px 0 10px;
  min-height: 32px;         /* стабилизируем высоту строки */
}
.RoutesProgressDetailsPage_filterTag__-4D8X {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #eef2ff;
  color: #1e40af;
  border: 1px solid #c7d2fe;
  border-radius: 999px;
  padding: 4px 8px;
  font-size: 12px;
  line-height: 1;           /* фиксируем высоту */
  height: 28px;             /* единая высота чипа */
  box-sizing: border-box;
  white-space: nowrap;      /* не переносим текст внутри чипа */
}
.RoutesProgressDetailsPage_tagX__arnXr {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  margin-left: 2px;
  font-size: 12px;
  line-height: 1;
  border-radius: 50%;
  background: transparent;
  border: 0;
  padding: 0;
  appearance: none;
  cursor: pointer;
  color: inherit;
}

/* KPI */
.RoutesProgressDetailsPage_kpiRow__zhzP2 {
  display: grid;
  grid-template-columns: repeat(4, minmax(0,1fr));
  gap: 10px;
  margin-bottom: 12px;
}
@media (max-width: 800px) { .RoutesProgressDetailsPage_kpiRow__zhzP2 { grid-template-columns: repeat(2,1fr); } }
.RoutesProgressDetailsPage_kpiBox__Zpka8 {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px;
}
.RoutesProgressDetailsPage_kpiLabel__xBBUz { font-size: 12px; color: #6b7280; }
.RoutesProgressDetailsPage_kpiValue__1DFVi { margin-top: 4px; font-size: 18px; font-weight: 800; color: #111827; }

/* Overview */
.RoutesProgressDetailsPage_overviewGrid__BpJ6P {
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
}
@media (max-width: 1000px) { .RoutesProgressDetailsPage_overviewGrid__BpJ6P { grid-template-columns: 1fr; } }

.RoutesProgressDetailsPage_timelineCard__RQV4\\+, .RoutesProgressDetailsPage_mapCard__0oL3J, .RoutesProgressDetailsPage_tableCard__pKLVk {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}
.RoutesProgressDetailsPage_blockHeader__DxcDC {
  padding: 10px 12px;
  font-weight: 800;
  font-size: 14px;
  color: #111827;
  border-bottom: 1px solid #f3f4f6;
  background: #fafafb;
}

.RoutesProgressDetailsPage_timelineRow__h6uZt {
  padding: 12px;
  display: flex;
  gap: 10px;
  align-items: center;
  overflow-x: auto;
  min-height: 84px;
}
.RoutesProgressDetailsPage_timelineRow__h6uZt::-webkit-scrollbar { height: 8px; }
.RoutesProgressDetailsPage_timelineRow__h6uZt::-webkit-scrollbar-thumb { background: #e5e7eb; border-radius: 999px; }
.RoutesProgressDetailsPage_eventChip__If3NA {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  padding: 8px 10px;
  border-radius: 999px;
  color: #fff;
  font-weight: 700;
  font-size: 12px;
  box-shadow: 0 4px 10px rgba(0,0,0,.08);
}
.RoutesProgressDetailsPage_chip--ok__zUSne   { background: #16a34a; }
.RoutesProgressDetailsPage_chip--info__coDmm { background: #2563eb; }
.RoutesProgressDetailsPage_chip--warn__UZvTI { background: #f59e0b; }
.RoutesProgressDetailsPage_eventLabel__dDsNf { max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.RoutesProgressDetailsPage_eventTime__-QeAr  { opacity: .95; font-weight: 800; }
.RoutesProgressDetailsPage_muted__l3xtj { color: #9ca3af; font-size: 13px; }
.RoutesProgressDetailsPage_mapStub__yn75t { padding: 18px; color: #6b7280; }

/* Nested table */
.RoutesProgressDetailsPage_tableWrap__0q5gF { width: 100%; overflow-x: auto; }
.RoutesProgressDetailsPage_table__IACJo { width: 100%; border-collapse: collapse; }
.RoutesProgressDetailsPage_table__IACJo th, .RoutesProgressDetailsPage_table__IACJo td {
  padding: 8px 10px;
  border-bottom: 1px solid #f3f4f6;
  font-size: 14px;
}
.RoutesProgressDetailsPage_table__IACJo thead th { background: #fafafb; color: #374151; text-align: left; font-weight: 800; }
.RoutesProgressDetailsPage_groupRow__4PK\\+E { background: #fff; }
.RoutesProgressDetailsPage_childRow__sHHQv { background: #fcfcfd; }

.RoutesProgressDetailsPage_expandBtn__CM07D {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  width: 28px;
  height: 28px;
  line-height: 1;
}
.RoutesProgressDetailsPage_linkBtn__zvk4w {
  border: 0;
  background: transparent;
  color: #2563eb;
  cursor: pointer;
  padding: 0;
}
.RoutesProgressDetailsPage_linkBtn__zvk4w:hover { text-decoration: underline; }

.RoutesProgressDetailsPage_colRoute__sGuUs { width: 120px; }
.RoutesProgressDetailsPage_colNumber__9wv5x { width: 100px; }
.RoutesProgressDetailsPage_colPerson__5Ebg7 { min-width: 160px; }
.RoutesProgressDetailsPage_colStatus__SQNzW { width: 140px; }
.RoutesProgressDetailsPage_colTimeCheck__gfqOc { min-width: 220px; }
.RoutesProgressDetailsPage_colAddr__v\\+jMW { max-width: 420px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

.RoutesProgressDetailsPage_progressBar__2zZG- {
  margin-top: 4px;
  height: 8px;
  background: #f3f4f6;
  border-radius: 999px;
  overflow: hidden;
  display: flex;
}
.RoutesProgressDetailsPage_pbDelivered__lY-p2   { background: #16a34a; }
.RoutesProgressDetailsPage_pbOpened__5XcyD      { background: #2563eb; }
.RoutesProgressDetailsPage_pbUndelivered__yZhAB { background: #ef4444; }
.RoutesProgressDetailsPage_progressLegend__FQFfU {
  display: flex;
  gap: 10px;
  color: #6b7280;
  font-size: 12px;
  margin-top: 4px;
}
.RoutesProgressDetailsPage_dim__qgsCq { color: #6b7280; font-size: 13px; }
.RoutesProgressDetailsPage_checkOk__VNylU { color: #16a34a; font-weight: 700; margin-left: 8px; }
.RoutesProgressDetailsPage_checkFail__q3H2U { color: #ef4444; font-weight: 700; margin-left: 8px; }

/* Drawer (sheet) */
.RoutesProgressDetailsPage_drawerOverlay__RKFu5 {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.45);
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  z-index: 9999;
}
.RoutesProgressDetailsPage_drawer__U5Ol6 {
  width: 460px;
  max-width: 100%;
  background: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
}
@media (max-width: 768px) {
  .RoutesProgressDetailsPage_drawerOverlay__RKFu5 { align-items: flex-end; }
  .RoutesProgressDetailsPage_drawer__U5Ol6 {
    width: 100%;
    height: 88vh;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }
}

.RoutesProgressDetailsPage_drawerHeader__hk\\+66 {
  position: relative;
  padding: 10px 12px 8px;
  border-bottom: 1px solid #f3f4f6;
  background: #fafafb;
}
.RoutesProgressDetailsPage_drawerGrabber__eURMi {
  width: 44px;
  height: 5px;
  background: #e5e7eb;
  border-radius: 999px;
  margin: 4px auto 8px;
}
.RoutesProgressDetailsPage_drawerTabs__prhCZ { display: flex; gap: 6px; }
.RoutesProgressDetailsPage_drawerTab__HpG-T {
  padding: 6px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  background: #fff;
  cursor: pointer;
  font-weight: 700;
  font-size: 13px;
}
.RoutesProgressDetailsPage_drawerTabActive__oWpe1 { background: #111827; color: #fff; border-color: #111827; }
.RoutesProgressDetailsPage_drawerClose__YYLII {
  position: absolute;
  right: 8px;
  top: 6px;
  border: 0;
  background: transparent;
  font-size: 20px;
  cursor: pointer;
  color: #6b7280;
}

/* Dates + presets inside drawer */
.RoutesProgressDetailsPage_drawerDates__Ip8l7 {
  padding: 10px 12px;
  border-bottom: 1px solid #f3f4f6;
  background: #fff;
}
.RoutesProgressDetailsPage_quickChips__jGSPU { display: flex; gap: 8px; flex-wrap: wrap; }
.RoutesProgressDetailsPage_chip__YuAZU {
  padding: 6px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  background: #fff;
  cursor: pointer;
}
.RoutesProgressDetailsPage_dateInputs__w9jOV {
  display: grid;
  grid-template-columns: auto 1fr auto 1fr;
  gap: 8px;
  align-items: center;
  margin-top: 8px;
}
.RoutesProgressDetailsPage_dateInputs__w9jOV input {
  padding: 6px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
}

.RoutesProgressDetailsPage_drawerBody__Qdw\\+y { padding: 10px 12px; overflow: auto; flex: 1 1; }

/* Status filters */
.RoutesProgressDetailsPage_statusFilters__fiX6W { display: grid; gap: 6px; margin-bottom: 10px; }
.RoutesProgressDetailsPage_checkItem__I-\\+Rg { display: inline-flex; align-items: center; gap: 8px; }

/* Search + actions in drawer */
.RoutesProgressDetailsPage_searchRow__9BjIW {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
}
.RoutesProgressDetailsPage_searchInput__8ueBy {
  flex: 1 1;
  padding: 6px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
}
.RoutesProgressDetailsPage_smallBtn__OsQyQ {
  padding: 6px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
}

/* Routes list in drawer */
.RoutesProgressDetailsPage_routesList__eMNZ9 { display: grid; gap: 8px; }
.RoutesProgressDetailsPage_routeRow__mX1Nt {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 10px;
  align-items: center;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 8px;
}
.RoutesProgressDetailsPage_routeRowChecked__HgX2n { outline: 2px solid rgba(59,130,246,.25); }
.RoutesProgressDetailsPage_routeRow__mX1Nt input { transform: scale(1.1); }
.RoutesProgressDetailsPage_routeRowMain__jvsSe { min-width: 0; }
.RoutesProgressDetailsPage_rowTop__Px3G4 { display: flex; gap: 8px; align-items: baseline; }
.RoutesProgressDetailsPage_rowMid__D-pMc { display: flex; gap: 12px; flex-wrap: wrap; margin-top: 2px; }

/* mini progress bar per route (drawer) */
.RoutesProgressDetailsPage_miniBar__3158t {
  margin-top: 6px;
  height: 6px;
  background: #f3f4f6;
  border-radius: 999px;
  overflow: hidden;
  display: flex;
}
.RoutesProgressDetailsPage_miniDelivered__smjfv   { background: #16a34a; }
.RoutesProgressDetailsPage_miniOpened__jJdkS      { background: #2563eb; }
.RoutesProgressDetailsPage_miniUndelivered__x1mUD { background: #ef4444; }

/* Person tab in drawer */
.RoutesProgressDetailsPage_personForm__VSo\\+u {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
}
.RoutesProgressDetailsPage_personInput__qX8W- {
  flex: 1 1;
  min-width: 220px;
  padding: 6px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
}
.RoutesProgressDetailsPage_personRole__oC45m {
  padding: 6px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Manager/RouteProgressDetails/RoutesProgressDetailsPage.module.css"],"names":[],"mappings":"AAAA,6CAAY,aAAa,EAAE;;AAE3B,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;AACA,0CAAS,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACvD,kDAAiB,aAAa,EAAE,QAAQ,EAAE;AAC1C;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB,OAAO,oCAAoC;EAC9D,kBAAkB;EAClB,gBAAgB,UAAU,gCAAgC;AAC5D;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,cAAc,YAAY,qBAAqB;EAC/C,YAAY,cAAc,uBAAuB;EACjD,sBAAsB;EACtB,mBAAmB,OAAO,mCAAmC;AAC/D;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,UAAU;EAEV,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,mBAAmB;AACrB;AACA,4BAA4B,2CAAU,oCAAoC,EAAE,EAAE;AAC9E;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA,6CAAY,eAAe,EAAE,cAAc,EAAE;AAC7C,6CAAY,eAAe,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAEhF,aAAa;AACb;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;AACrB;AACA,6BAA6B,iDAAgB,0BAA0B,EAAE,EAAE;;AAE3E;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;AACA,mEAAkC,WAAW,EAAE;AAC/C,yEAAwC,mBAAmB,EAAE,oBAAoB,EAAE;AACnF;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;AACA,+CAAc,mBAAmB,EAAE;AACnC,+CAAc,mBAAmB,EAAE;AACnC,+CAAc,mBAAmB,EAAE;AACnC,+CAAc,gBAAgB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAChG,+CAAc,YAAY,EAAE,gBAAgB,EAAE;AAC9C,0CAAS,cAAc,EAAE,eAAe,EAAE;AAC1C,4CAAW,aAAa,EAAE,cAAc,EAAE;;AAE1C,iBAAiB;AACjB,8CAAa,WAAW,EAAE,gBAAgB,EAAE;AAC5C,0CAAS,WAAW,EAAE,yBAAyB,EAAE;AACjD;EACE,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;AACA,mDAAkB,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC3F,8CAAY,gBAAgB,EAAE;AAC9B,6CAAY,mBAAmB,EAAE;;AAEjC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;AACZ;AACA,kDAAiB,0BAA0B,EAAE;;AAE7C,6CAAY,YAAY,EAAE;AAC1B,8CAAa,YAAY,EAAE;AAC3B,8CAAa,gBAAgB,EAAE;AAC/B,8CAAa,YAAY,EAAE;AAC3B,iDAAgB,gBAAgB,EAAE;AAClC,6CAAW,gBAAgB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;;AAE7F;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;AACA,kDAAiB,mBAAmB,EAAE;AACtC,kDAAiB,mBAAmB,EAAE;AACtC,kDAAiB,mBAAmB,EAAE;AACtC;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA,wCAAO,cAAc,EAAE,eAAe,EAAE;AACxC,4CAAW,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC/D,8CAAa,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAEjE,mBAAmB;AACnB;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kDAAiB,qBAAqB,EAAE;EACxC;IACE,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,6BAA6B;EAC/B;AACF;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;AACtB;AACA,+CAAc,aAAa,EAAE,QAAQ,EAAE;AACvC;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA,oDAAmB,mBAAmB,EAAE,WAAW,EAAE,qBAAqB,EAAE;AAC5E;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;AACA,+CAAc,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE;AACxD;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,wCAAwC;EACxC,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gDAAc,kBAAkB,EAAE,cAAc,EAAE,SAAO,EAAE;;AAE3D,mBAAmB;AACnB,kDAAiB,aAAa,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AAC/D,+CAAa,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAElE,+BAA+B;AAC/B;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B,+CAAc,aAAa,EAAE,QAAQ,EAAE;AACvC;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;AACA,oDAAmB,uCAAuC,EAAE;AAC5D,mDAAkB,qBAAqB,EAAE;AACzC,iDAAgB,YAAY,EAAE;AAC9B,2CAAU,aAAa,EAAE,QAAQ,EAAE,qBAAqB,EAAE;AAC1D,2CAAU,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE,eAAe,EAAE;;AAEtE,yCAAyC;AACzC;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;AACf;AACA,oDAAmB,mBAAmB,EAAE;AACxC,oDAAmB,mBAAmB,EAAE;AACxC,oDAAmB,mBAAmB,EAAE;;AAExC,yBAAyB;AACzB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".pageRoot { padding: 16px; }\r\n\r\n/* Header */\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 12px;\r\n}\r\n.title { margin: 0; font-size: 20px; font-weight: 800; }\r\n.headerActions { display: flex; gap: 8px; }\r\n.primaryBtn {\r\n  padding: 6px 12px;\r\n  border-radius: 999px;\r\n  background: #111827;\r\n  color: #fff;\r\n  border: 1px solid #111827;\r\n  font-weight: 800;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Active filter tags (фикс высоты, выравнивание) */\r\n.activeFilters {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n  align-items: center;      /* фикс вертикального выравнивания */\r\n  margin: 6px 0 10px;\r\n  min-height: 32px;         /* стабилизируем высоту строки */\r\n}\r\n.filterTag {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  background: #eef2ff;\r\n  color: #1e40af;\r\n  border: 1px solid #c7d2fe;\r\n  border-radius: 999px;\r\n  padding: 4px 8px;\r\n  font-size: 12px;\r\n  line-height: 1;           /* фиксируем высоту */\r\n  height: 28px;             /* единая высота чипа */\r\n  box-sizing: border-box;\r\n  white-space: nowrap;      /* не переносим текст внутри чипа */\r\n}\r\n.tagX {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 16px;\r\n  height: 16px;\r\n  margin-left: 2px;\r\n  font-size: 12px;\r\n  line-height: 1;\r\n  border-radius: 50%;\r\n  background: transparent;\r\n  border: 0;\r\n  padding: 0;\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  cursor: pointer;\r\n  color: inherit;\r\n}\r\n\r\n/* KPI */\r\n.kpiRow {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0,1fr));\r\n  gap: 10px;\r\n  margin-bottom: 12px;\r\n}\r\n@media (max-width: 800px) { .kpiRow { grid-template-columns: repeat(2,1fr); } }\r\n.kpiBox {\r\n  background: #f9fafb;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  padding: 10px;\r\n}\r\n.kpiLabel { font-size: 12px; color: #6b7280; }\r\n.kpiValue { margin-top: 4px; font-size: 18px; font-weight: 800; color: #111827; }\r\n\r\n/* Overview */\r\n.overviewGrid {\r\n  display: grid;\r\n  grid-template-columns: 1.1fr 1fr;\r\n  gap: 12px;\r\n  margin-bottom: 12px;\r\n}\r\n@media (max-width: 1000px) { .overviewGrid { grid-template-columns: 1fr; } }\r\n\r\n.timelineCard, .mapCard, .tableCard {\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  background: #fff;\r\n}\r\n.blockHeader {\r\n  padding: 10px 12px;\r\n  font-weight: 800;\r\n  font-size: 14px;\r\n  color: #111827;\r\n  border-bottom: 1px solid #f3f4f6;\r\n  background: #fafafb;\r\n}\r\n\r\n.timelineRow {\r\n  padding: 12px;\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n  overflow-x: auto;\r\n  min-height: 84px;\r\n}\r\n.timelineRow::-webkit-scrollbar { height: 8px; }\r\n.timelineRow::-webkit-scrollbar-thumb { background: #e5e7eb; border-radius: 999px; }\r\n.eventChip {\r\n  display: inline-flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  padding: 8px 10px;\r\n  border-radius: 999px;\r\n  color: #fff;\r\n  font-weight: 700;\r\n  font-size: 12px;\r\n  box-shadow: 0 4px 10px rgba(0,0,0,.08);\r\n}\r\n.chip--ok   { background: #16a34a; }\r\n.chip--info { background: #2563eb; }\r\n.chip--warn { background: #f59e0b; }\r\n.eventLabel { max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\r\n.eventTime  { opacity: .95; font-weight: 800; }\r\n.muted { color: #9ca3af; font-size: 13px; }\r\n.mapStub { padding: 18px; color: #6b7280; }\r\n\r\n/* Nested table */\r\n.tableWrap { width: 100%; overflow-x: auto; }\r\n.table { width: 100%; border-collapse: collapse; }\r\n.table th, .table td {\r\n  padding: 8px 10px;\r\n  border-bottom: 1px solid #f3f4f6;\r\n  font-size: 14px;\r\n}\r\n.table thead th { background: #fafafb; color: #374151; text-align: left; font-weight: 800; }\r\n.groupRow { background: #fff; }\r\n.childRow { background: #fcfcfd; }\r\n\r\n.expandBtn {\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  background: #fff;\r\n  cursor: pointer;\r\n  width: 28px;\r\n  height: 28px;\r\n  line-height: 1;\r\n}\r\n.linkBtn {\r\n  border: 0;\r\n  background: transparent;\r\n  color: #2563eb;\r\n  cursor: pointer;\r\n  padding: 0;\r\n}\r\n.linkBtn:hover { text-decoration: underline; }\r\n\r\n.colRoute { width: 120px; }\r\n.colNumber { width: 100px; }\r\n.colPerson { min-width: 160px; }\r\n.colStatus { width: 140px; }\r\n.colTimeCheck { min-width: 220px; }\r\n.colAddr { max-width: 420px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\r\n\r\n.progressBar {\r\n  margin-top: 4px;\r\n  height: 8px;\r\n  background: #f3f4f6;\r\n  border-radius: 999px;\r\n  overflow: hidden;\r\n  display: flex;\r\n}\r\n.pbDelivered   { background: #16a34a; }\r\n.pbOpened      { background: #2563eb; }\r\n.pbUndelivered { background: #ef4444; }\r\n.progressLegend {\r\n  display: flex;\r\n  gap: 10px;\r\n  color: #6b7280;\r\n  font-size: 12px;\r\n  margin-top: 4px;\r\n}\r\n.dim { color: #6b7280; font-size: 13px; }\r\n.checkOk { color: #16a34a; font-weight: 700; margin-left: 8px; }\r\n.checkFail { color: #ef4444; font-weight: 700; margin-left: 8px; }\r\n\r\n/* Drawer (sheet) */\r\n.drawerOverlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0,0,0,.45);\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: stretch;\r\n  z-index: 9999;\r\n}\r\n.drawer {\r\n  width: 460px;\r\n  max-width: 100%;\r\n  background: #fff;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n@media (max-width: 768px) {\r\n  .drawerOverlay { align-items: flex-end; }\r\n  .drawer {\r\n    width: 100%;\r\n    height: 88vh;\r\n    border-top-left-radius: 16px;\r\n    border-top-right-radius: 16px;\r\n  }\r\n}\r\n\r\n.drawerHeader {\r\n  position: relative;\r\n  padding: 10px 12px 8px;\r\n  border-bottom: 1px solid #f3f4f6;\r\n  background: #fafafb;\r\n}\r\n.drawerGrabber {\r\n  width: 44px;\r\n  height: 5px;\r\n  background: #e5e7eb;\r\n  border-radius: 999px;\r\n  margin: 4px auto 8px;\r\n}\r\n.drawerTabs { display: flex; gap: 6px; }\r\n.drawerTab {\r\n  padding: 6px 10px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 999px;\r\n  background: #fff;\r\n  cursor: pointer;\r\n  font-weight: 700;\r\n  font-size: 13px;\r\n}\r\n.drawerTabActive { background: #111827; color: #fff; border-color: #111827; }\r\n.drawerClose {\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 6px;\r\n  border: 0;\r\n  background: transparent;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  color: #6b7280;\r\n}\r\n\r\n/* Dates + presets inside drawer */\r\n.drawerDates {\r\n  padding: 10px 12px;\r\n  border-bottom: 1px solid #f3f4f6;\r\n  background: #fff;\r\n}\r\n.quickChips { display: flex; gap: 8px; flex-wrap: wrap; }\r\n.chip {\r\n  padding: 6px 10px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 999px;\r\n  background: #fff;\r\n  cursor: pointer;\r\n}\r\n.dateInputs {\r\n  display: grid;\r\n  grid-template-columns: auto 1fr auto 1fr;\r\n  gap: 8px;\r\n  align-items: center;\r\n  margin-top: 8px;\r\n}\r\n.dateInputs input {\r\n  padding: 6px 8px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n}\r\n\r\n.drawerBody { padding: 10px 12px; overflow: auto; flex: 1; }\r\n\r\n/* Status filters */\r\n.statusFilters { display: grid; gap: 6px; margin-bottom: 10px; }\r\n.checkItem { display: inline-flex; align-items: center; gap: 8px; }\r\n\r\n/* Search + actions in drawer */\r\n.searchRow {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  margin-bottom: 8px;\r\n}\r\n.searchInput {\r\n  flex: 1;\r\n  padding: 6px 8px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n}\r\n.smallBtn {\r\n  padding: 6px 10px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Routes list in drawer */\r\n.routesList { display: grid; gap: 8px; }\r\n.routeRow {\r\n  display: grid;\r\n  grid-template-columns: auto 1fr;\r\n  gap: 10px;\r\n  align-items: center;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 10px;\r\n  padding: 8px;\r\n}\r\n.routeRowChecked { outline: 2px solid rgba(59,130,246,.25); }\r\n.routeRow input { transform: scale(1.1); }\r\n.routeRowMain { min-width: 0; }\r\n.rowTop { display: flex; gap: 8px; align-items: baseline; }\r\n.rowMid { display: flex; gap: 12px; flex-wrap: wrap; margin-top: 2px; }\r\n\r\n/* mini progress bar per route (drawer) */\r\n.miniBar {\r\n  margin-top: 6px;\r\n  height: 6px;\r\n  background: #f3f4f6;\r\n  border-radius: 999px;\r\n  overflow: hidden;\r\n  display: flex;\r\n}\r\n.miniDelivered   { background: #16a34a; }\r\n.miniOpened      { background: #2563eb; }\r\n.miniUndelivered { background: #ef4444; }\r\n\r\n/* Person tab in drawer */\r\n.personForm {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  margin-bottom: 8px;\r\n  flex-wrap: wrap;\r\n}\r\n.personInput {\r\n  flex: 1;\r\n  min-width: 220px;\r\n  padding: 6px 8px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n}\r\n.personRole {\r\n  padding: 6px 8px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageRoot": `RoutesProgressDetailsPage_pageRoot__oT7Sv`,
	"header": `RoutesProgressDetailsPage_header__ryNXj`,
	"title": `RoutesProgressDetailsPage_title__APUaS`,
	"headerActions": `RoutesProgressDetailsPage_headerActions__5aGsz`,
	"primaryBtn": `RoutesProgressDetailsPage_primaryBtn__5smmY`,
	"activeFilters": `RoutesProgressDetailsPage_activeFilters__gX0c6`,
	"filterTag": `RoutesProgressDetailsPage_filterTag__-4D8X`,
	"tagX": `RoutesProgressDetailsPage_tagX__arnXr`,
	"kpiRow": `RoutesProgressDetailsPage_kpiRow__zhzP2`,
	"kpiBox": `RoutesProgressDetailsPage_kpiBox__Zpka8`,
	"kpiLabel": `RoutesProgressDetailsPage_kpiLabel__xBBUz`,
	"kpiValue": `RoutesProgressDetailsPage_kpiValue__1DFVi`,
	"overviewGrid": `RoutesProgressDetailsPage_overviewGrid__BpJ6P`,
	"timelineCard": `RoutesProgressDetailsPage_timelineCard__RQV4+`,
	"mapCard": `RoutesProgressDetailsPage_mapCard__0oL3J`,
	"tableCard": `RoutesProgressDetailsPage_tableCard__pKLVk`,
	"blockHeader": `RoutesProgressDetailsPage_blockHeader__DxcDC`,
	"timelineRow": `RoutesProgressDetailsPage_timelineRow__h6uZt`,
	"eventChip": `RoutesProgressDetailsPage_eventChip__If3NA`,
	"chip--ok": `RoutesProgressDetailsPage_chip--ok__zUSne`,
	"chip--info": `RoutesProgressDetailsPage_chip--info__coDmm`,
	"chip--warn": `RoutesProgressDetailsPage_chip--warn__UZvTI`,
	"eventLabel": `RoutesProgressDetailsPage_eventLabel__dDsNf`,
	"eventTime": `RoutesProgressDetailsPage_eventTime__-QeAr`,
	"muted": `RoutesProgressDetailsPage_muted__l3xtj`,
	"mapStub": `RoutesProgressDetailsPage_mapStub__yn75t`,
	"tableWrap": `RoutesProgressDetailsPage_tableWrap__0q5gF`,
	"table": `RoutesProgressDetailsPage_table__IACJo`,
	"groupRow": `RoutesProgressDetailsPage_groupRow__4PK+E`,
	"childRow": `RoutesProgressDetailsPage_childRow__sHHQv`,
	"expandBtn": `RoutesProgressDetailsPage_expandBtn__CM07D`,
	"linkBtn": `RoutesProgressDetailsPage_linkBtn__zvk4w`,
	"colRoute": `RoutesProgressDetailsPage_colRoute__sGuUs`,
	"colNumber": `RoutesProgressDetailsPage_colNumber__9wv5x`,
	"colPerson": `RoutesProgressDetailsPage_colPerson__5Ebg7`,
	"colStatus": `RoutesProgressDetailsPage_colStatus__SQNzW`,
	"colTimeCheck": `RoutesProgressDetailsPage_colTimeCheck__gfqOc`,
	"colAddr": `RoutesProgressDetailsPage_colAddr__v+jMW`,
	"progressBar": `RoutesProgressDetailsPage_progressBar__2zZG-`,
	"pbDelivered": `RoutesProgressDetailsPage_pbDelivered__lY-p2`,
	"pbOpened": `RoutesProgressDetailsPage_pbOpened__5XcyD`,
	"pbUndelivered": `RoutesProgressDetailsPage_pbUndelivered__yZhAB`,
	"progressLegend": `RoutesProgressDetailsPage_progressLegend__FQFfU`,
	"dim": `RoutesProgressDetailsPage_dim__qgsCq`,
	"checkOk": `RoutesProgressDetailsPage_checkOk__VNylU`,
	"checkFail": `RoutesProgressDetailsPage_checkFail__q3H2U`,
	"drawerOverlay": `RoutesProgressDetailsPage_drawerOverlay__RKFu5`,
	"drawer": `RoutesProgressDetailsPage_drawer__U5Ol6`,
	"drawerHeader": `RoutesProgressDetailsPage_drawerHeader__hk+66`,
	"drawerGrabber": `RoutesProgressDetailsPage_drawerGrabber__eURMi`,
	"drawerTabs": `RoutesProgressDetailsPage_drawerTabs__prhCZ`,
	"drawerTab": `RoutesProgressDetailsPage_drawerTab__HpG-T`,
	"drawerTabActive": `RoutesProgressDetailsPage_drawerTabActive__oWpe1`,
	"drawerClose": `RoutesProgressDetailsPage_drawerClose__YYLII`,
	"drawerDates": `RoutesProgressDetailsPage_drawerDates__Ip8l7`,
	"quickChips": `RoutesProgressDetailsPage_quickChips__jGSPU`,
	"chip": `RoutesProgressDetailsPage_chip__YuAZU`,
	"dateInputs": `RoutesProgressDetailsPage_dateInputs__w9jOV`,
	"drawerBody": `RoutesProgressDetailsPage_drawerBody__Qdw+y`,
	"statusFilters": `RoutesProgressDetailsPage_statusFilters__fiX6W`,
	"checkItem": `RoutesProgressDetailsPage_checkItem__I-+Rg`,
	"searchRow": `RoutesProgressDetailsPage_searchRow__9BjIW`,
	"searchInput": `RoutesProgressDetailsPage_searchInput__8ueBy`,
	"smallBtn": `RoutesProgressDetailsPage_smallBtn__OsQyQ`,
	"routesList": `RoutesProgressDetailsPage_routesList__eMNZ9`,
	"routeRow": `RoutesProgressDetailsPage_routeRow__mX1Nt`,
	"routeRowChecked": `RoutesProgressDetailsPage_routeRowChecked__HgX2n`,
	"routeRowMain": `RoutesProgressDetailsPage_routeRowMain__jvsSe`,
	"rowTop": `RoutesProgressDetailsPage_rowTop__Px3G4`,
	"rowMid": `RoutesProgressDetailsPage_rowMid__D-pMc`,
	"miniBar": `RoutesProgressDetailsPage_miniBar__3158t`,
	"miniDelivered": `RoutesProgressDetailsPage_miniDelivered__smjfv`,
	"miniOpened": `RoutesProgressDetailsPage_miniOpened__jJdkS`,
	"miniUndelivered": `RoutesProgressDetailsPage_miniUndelivered__x1mUD`,
	"personForm": `RoutesProgressDetailsPage_personForm__VSo+u`,
	"personInput": `RoutesProgressDetailsPage_personInput__qX8W-`,
	"personRole": `RoutesProgressDetailsPage_personRole__oC45m`
};
export default ___CSS_LOADER_EXPORT___;
